import css from 'styled-jsx/css'
import { colors, fontWeights } from 'theme'

export const logoutSessionsStyles = css`
  .user-session-logout-container {
    margin: 0 auto;
    width: 100%;
  }

  .user-session-logout-container-body {
    margin-top: 1rem;
  }

  .session-logout-warning {
    text-align: center;
  }
  .session-logout-warning :global(i) {
    color: ${colors.danger};
    margin-right: 0.5rem;
  }
  .logout-button-container {
    display: flex;
    justify-content: center;
  }
  .logout-button-container :global(.logout-button) {
    padding: 0 2rem;
    font-weight: ${fontWeights.semiBold};
  }
`

export const sessionStyles = css`
  .session {
    display: grid;
    grid-template-columns: 3.2rem 1fr;
    padding: 1rem 0;
  }
  .session.in-active {
    color: ${colors.gray};
  }

  .session-details {
    margin-left: 1rem;
  }

  .session-details .last-login {
    display: flex;
    align-items: stretch;
    color: ${colors.gray};
  }
  .session-details .last-login span {
    margin-right: 0.2rem;
  }

  .session-alias, .session-info {
    margin: 0.2rem 0 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .session-info {
    color: ${colors.gray};
  }
`